import {css} from '@emotion/css';

import {spacing, fonts} from '@fo/shared/styles/variables';

const styles = {
  header: (alignment = fonts.alignment.INHERIT): string => css`
    label: header;
    margin-top: 0;
    margin-bottom: ${spacing.XS};
    color: currentColor;
    font-family: ${fonts.family.SECONDARY};
    font-weight: ${fonts.weight.REGULAR};
    line-height: ${fonts.lineHeight.HEADING};
    text-align: ${alignment};
  `,
};

export default styles;
